/* eslint-disable max-lines-per-function */
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Link as RouterLink} from 'react-router-dom';
import locale from '../locale/Localization';
import {checkRolePermissions} from '../permissions/permissions';
import * as con from '../utils/constants';
import Login from './Login';
import NavIconButton from './NavIconButton';
import UserMenu from './UserMenu';

const mapStateToProps = (state: Object) => {
  return {user: state.user, roles: state.roles, archives: state.archives};
};

/**
 * The naviagtion component for the sdms register portal.
 * @return {string} the compnent conents.
 */
const ConnectedNavigation = ({user, roles, archives}) => {
  const [selected, setSelected] = React.useState(window.location.pathname);
  const userIsLoggedIn = user.firstNames !== 'Guest';

  const getColor = (nav: string) => {
    return nav === selected ? con.NAV_COLOR_SELECTED : con.NAV_COLOR_UNSELECTED;
  };

  const displayApplications = () => {
    return (
      checkRolePermissions(roles, 'VIEW', 'Applications') ||
      checkRolePermissions(roles, 'VIEW', 'Person Management')
    );
  };

  return (
    <div style={{marginRight: '-1.5em'}}>
      {
        // NEWS
        !userIsLoggedIn && (
          <Button
            color='inherit'
            component={RouterLink}
            onClick={() => setSelected(con.NAV_SELECT_NEWS)}
            style={{
              textDecoration:
                selected === con.NAV_SELECT_NEWS ? 'underline' : ''
            }}
            to={con.NAV_SELECT_NEWS}
          >
            {locale.navigationNews}
          </Button>
        )
      }
      {userIsLoggedIn && (
        <NavIconButton
          color={getColor(con.NAV_SELECT_NEWS)}
          component={RouterLink}
          label={locale.navigationNews}
          nav={con.NAV_SELECT_NEWS}
          onClick={setSelected}
        />
      )}
      {
        // DASHBOARD
        checkRolePermissions(roles, 'VIEW', 'UserProfile') && (
          <NavIconButton
            color={getColor(con.NAV_SELECT_HOME)}
            component={RouterLink}
            label={locale.navigationHome}
            nav={con.NAV_SELECT_HOME}
            onClick={setSelected}
          />
        )
      }
      {
        // APPLICATIONS
        displayApplications() && (
          <NavIconButton
            color={getColor(con.NAV_SELECT_APPLICATIONS)}
            component={RouterLink}
            label={locale.notaryApplicationsTitle}
            nav={con.NAV_SELECT_APPLICATIONS}
            onClick={setSelected}
          />
        )
      }
      {
        // EMPLOYEE MANAGEMENT
        checkRolePermissions(roles, 'VIEW', 'Employee Management') && (
          <NavIconButton
            color={getColor(con.NAV_SELECT_EMPLOYEE)}
            component={RouterLink}
            label={locale.navigationEmployees}
            nav={con.NAV_SELECT_EMPLOYEE}
            onClick={setSelected}
          />
        )
      }
      {
        // REGISTER
        !userIsLoggedIn && (
          <Button
            color='inherit'
            component={RouterLink}
            onClick={() => setSelected(con.NAV_SELECT_REGISTER)}
            style={{
              textDecoration:
                selected === con.NAV_SELECT_REGISTER ? 'underline' : ''
            }}
            to={con.NAV_SELECT_REGISTER}
          >
            {locale.navigationRegister}
          </Button>
        )
      }
      {userIsLoggedIn && (
        <NavIconButton
          color={getColor(con.NAV_SELECT_REGISTER)}
          component={RouterLink}
          label={locale.navigationRegister}
          nav={con.NAV_SELECT_REGISTER}
          onClick={setSelected}
        />
      )}
      {
        // ARCHIVE
        Object.keys(archives).length > 0 && (
          <NavIconButton
            color={getColor(con.NAV_SELECT_ARCHIVE)}
            component={RouterLink}
            label={locale.navigationArchive}
            nav={con.NAV_SELECT_ARCHIVE}
            onClick={setSelected}
          />
        )
      }
      {
        // SIGNER
        checkRolePermissions(roles, 'VIEW', 'UserProfile') && (
          <NavIconButton
            color={getColor(con.NAV_SELECT_SIGNER)}
            component={RouterLink}
            label={locale.signerTitle}
            nav={con.NAV_SELECT_SIGNER}
            onClick={setSelected}
          />
        )
      }
      {
        // LOGIN
        !userIsLoggedIn && (
          <React.Fragment>
            <Login />
          </React.Fragment>
        )
      }
      {
        // PROFILE
        userIsLoggedIn && (
          <UserMenu
            color={getColor(con.NAV_SELECT_PROFILE)}
            onClick={setSelected}
            showProfile={user.type === 'NOTARY'}
          />
        )
      }
    </div>
  );
};

ConnectedNavigation.propTypes = {
  archives: PropTypes.array,
  roles: PropTypes.array,
  user: PropTypes.object
};

const Navigation = connect(mapStateToProps)(ConnectedNavigation);
export default Navigation;
